import team_member_EdW from '../assets/images/team_members/team_member_EdW.jpg';
import team_member_EdW_Hover from '../assets/images/team_members/team_member_EdW_Hover.jpg';
import team_member_AndrewK from '../assets/images/team_members/team_member_AndrewK.jpg';
import team_member_AndrewK_Hover from '../assets/images/team_members/team_member_AndrewK_Hover.jpg';
import team_member_GregL from '../assets/images/team_members/team_member_GregL.jpg';
import team_member_GregL_Hover from '../assets/images/team_members/team_member_GregL_Hover.jpg';
import team_member_IanB from '../assets/images/team_members/team_member_IanB.jpg';
import team_member_IanB_Hover from '../assets/images/team_members/team_member_IanB_Hover.jpg';
import team_member_JeffN from '../assets/images/team_members/team_member_JeffN.jpg';
import team_member_JeffN_Hover from '../assets/images/team_members/team_member_JeffN_Hover.jpg';
import team_member_KevinD from '../assets/images/team_members/team_member_KevinD.jpg';
import team_member_KevinD_Hover from '../assets/images/team_members/team_member_KevinD_Hover.jpg';
import team_member_EricD from '../assets/images/team_members/team_member_EricD.jpg';
import team_member_EricD_Hover from '../assets/images/team_members/team_member_EricD_Hover.jpg';
import team_member_QuinnH from '../assets/images/team_members/team_member_QuinnH.jpg';
import team_member_QuinnH_Hover from '../assets/images/team_members/team_member_QuinnH_Hover.jpg';
import team_member_NicholasL from '../assets/images/team_members/team_member_NicholasL.jpg';
import team_member_NicholasL_Hover from '../assets/images/team_members/team_member_NicholasL_Hover.jpg';
import team_member_RebeccaJ from '../assets/images/team_members/team_member_RebeccaJ.jpg';
import team_member_RebeccaJ_Hover from '../assets/images/team_members/team_member_RebeccaJ_Hover.jpg';
import team_member_JoshuaV from '../assets/images/team_members/team_member_JoshuaV.jpg';
import team_member_JoshuaV_Hover from '../assets/images/team_members/team_member_JoshuaV_Hover.jpg';
import team_member_JennakaU from '../assets/images/team_members/team_member_JennakaU.jpg';
import team_member_JennakaU_Hover from '../assets/images/team_members/team_member_JennakaU_Hover.jpg';
import team_member_RandyF from '../assets/images/team_members/team_member_RandyF.jpg';
import team_member_RandyF_Hover from '../assets/images/team_members/team_member_RandyF_Hover.jpg';
import team_member_AndrewP from '../assets/images/team_members/team_member_AndrewP.jpg';
import team_member_AndrewP_Hover from '../assets/images/team_members/team_member_AndrewP_Hover.jpg';
import team_member_NickV from '../assets/images/team_members/team_member_NickV.jpg';
import team_member_NickV_Hover from '../assets/images/team_members/team_member_NickV_Hover.jpg';
import team_member_LeoB from '../assets/images/team_members/team_member_LeoB.jpg';
import team_member_LeoB_Hover from '../assets/images/team_members/team_member_LeoB_Hover.jpg';
import team_member_SimonL from '../assets/images/team_members/team_member_SimonL.jpg';
import team_member_SimonL_Hover from '../assets/images/team_members/team_member_SimonL_Hover.jpg';
import team_member_BrandonC from '../assets/images/team_members/team_member_BrandonC.jpg';
import team_member_BrandonC_Hover from '../assets/images/team_members/team_member_BrandonC_Hover.jpg';
import team_member_JacobbR from '../assets/images/team_members/team_member_JacobbR.jpg';
import team_member_JacobbR_Hover from '../assets/images/team_members/team_member_JacobbR_Hover.jpg';
import team_member_AndreS from '../assets/images/team_members/team_member_AndreS.jpg';
import team_member_AndreS_Hover from '../assets/images/team_members/team_member_AndreS_Hover.jpg';
import team_member_AvalonA from '../assets/images/team_members/team_member_AvalonA.jpg';
import team_member_AvalonA_Hover from '../assets/images/team_members/team_member_AvalonA_Hover.jpg';
import team_member_RachelL from '../assets/images/team_members/team_member_RachelL.jpg';
import team_member_RachelL_Hover from '../assets/images/team_members/team_member_RachelL_Hover.jpg';
import team_member_MatthewS from '../assets/images/team_members/team_member_MatthewS.jpg';
import team_member_MatthewS_Hover from '../assets/images/team_members/team_member_MatthewS_Hover.jpg';

export const AboutTeamData = [
    {
        name: 'Ed Wisniewski',
        designation: 'CTO',
        image: { src: team_member_EdW, alt: 'Ed Wisniewski' },
        hover: { src: team_member_EdW_Hover, alt: 'Ed Wisniewski' },
        social: []
    },
    {
        name: 'Andrew Kostuik',
        designation: 'Studio Director',
        image: { src: team_member_AndrewK, alt: 'Andrew Kostuik' },
        hover: { src: team_member_AndrewK_Hover, alt: 'Andrew Kostuik' },
        social: []
    },
    {
        name: 'Greg Lajeunesse',
        designation: 'IT Director',
        image: { src: team_member_GregL, alt: 'Greg Lajeunesse' },
        hover: { src: team_member_GregL_Hover, alt: 'Greg Lajeunesse' },
        social: []
    },
    {
        name: 'Rachel Labelle',
        designation: 'Producer',
        image: { src: team_member_RachelL, alt: 'Rachel Labelle' },
        hover: { src: team_member_RachelL_Hover, alt: 'Rachel Labelle' },
        social: []
    },
    {
        name: 'Ian Busch, P.Eng.',
        designation: 'Staff Engineer',
        image: { src: team_member_IanB, alt: 'Ian Busch' },
        hover: { src: team_member_IanB_Hover, alt: 'Ian Busch' },
        social: []
    },
    {
        name: 'Jeff Nicholls',
        designation: 'Systems Developer',
        image: { src: team_member_JeffN, alt: 'Jeff Nicholls' },
        hover: { src: team_member_JeffN_Hover, alt: 'Jeff Nicholls' },
        social: []
    },
    {
        name: 'Kevin Dallaire',
        designation: 'Lead Software Developer',
        image: { src: team_member_KevinD, alt: 'Kevin Dallaire' },
        hover: { src: team_member_KevinD_Hover, alt: 'Kevin Dallaire' },
        social: []
    },
    {
        name: 'Eric Daoust',
        designation: 'Software Developer',
        image: { src: team_member_EricD, alt: 'Eric Daoust' },
        hover: { src: team_member_EricD_Hover, alt: 'Eric Daoust' },
        social: []
    },
        {
        name: 'Randy Fortier',
        designation: 'Software Developer',
        image: { src: team_member_RandyF, alt: 'Randy Fortier' },
        hover: { src: team_member_RandyF_Hover, alt: 'Randy Fortier' },
        social: []
    },   
    {
        name: 'Joshua Vaters',
        designation: 'Senior Technical Artist',
        image: { src: team_member_JoshuaV, alt: 'Joshua Vaters' },
        hover: { src: team_member_JoshuaV_Hover, alt: 'Joshua Vaters' },
        social: []
    },
    {
        name: 'Jennaka Urisk',
        designation: 'UI/UX Lead',
        image: { src: team_member_JennakaU, alt: 'Jennaka Urisk' },
        hover: { src: team_member_JennakaU_Hover, alt: 'Jennaka Urisk' },
        social: []
    },
    {
        name: 'Nick Vildis',
        designation: 'Senior Generalist',
        image: { src: team_member_NickV, alt: 'Nick Vildis' },
        hover: { src: team_member_NickV_Hover, alt: 'Nick Vildis' },
        social: []
    },
    {
        name: 'Rebecca Joly',
        designation: 'Senior XR Developer',
        image: { src: team_member_RebeccaJ, alt: 'Rebecca Joly' },
        hover: { src: team_member_RebeccaJ_Hover, alt: 'Rebecca Joly' },
        social: []
    },
    {
        name: 'Quinn Henschel',
        designation: 'XR Developer',
        image: { src: team_member_QuinnH, alt: 'Quinn Henschel' },
        hover: { src: team_member_QuinnH_Hover, alt: 'Quinn Henschel' },
        social: []
    },
    {
        name: 'Nicholas Lamonica',
        designation: 'XR Developer',
        image: { src: team_member_NicholasL, alt: 'Nicholas Lamonica' },
        hover: { src: team_member_NicholasL_Hover, alt: 'Nicholas Lamonica' },
        social: []
    },    
    {
        name: 'Andrew Persechino',
        designation: 'XR Developer',
        image: { src: team_member_AndrewP, alt: 'Andrew Persechino' },
        hover: { src: team_member_AndrewP_Hover, alt: 'Andrew Persechino' },
        social: []
    },     
    {
        name: 'Léo Buono',
        designation: 'XR Developer',
        image: { src: team_member_LeoB, alt: 'Léo Buono' },
        hover: { src: team_member_LeoB_Hover, alt: 'Léo Buono' },
        social: []
    },
    {
        name: 'Simon Lopez',
        designation: 'XR Developer',
        image: { src: team_member_SimonL, alt: 'Simon Lopez' },
        hover: { src: team_member_SimonL_Hover, alt: 'Simon Lopez' },
        social: []
    },
    {
        name: 'Brandon Cotesta',
        designation: 'XR Developer',
        image: { src: team_member_BrandonC, alt: 'Brandon Cotesta' },
        hover: { src: team_member_BrandonC_Hover, alt: 'Brandon Cotesta' },
        social: []
    },
    {
        name: 'Jacobb Rozon',
        designation: 'XR Developer',
        image: { src: team_member_JacobbR, alt: 'Jacobb Rozon' },
        hover: { src: team_member_JacobbR_Hover, alt: 'Jacobb Rozon' },
        social: []
    },
    {
        name: 'Andre Sokolow',
        designation: 'Lead 3D Artist',
        image: { src: team_member_AndreS, alt: 'Andre Sokolow' },
        hover: { src: team_member_AndreS_Hover, alt: 'Andre Sokolow' },
        social: []
    },
    {
        name: 'Avalon Appleton',
        designation: '3D Artist',
        image: { src: team_member_AvalonA, alt: 'Avalon Appleton' },
        hover: { src: team_member_AvalonA_Hover, alt: 'Avalon Appleton' },
        social: []
    },
    {
        name: 'Matthew Silvestri',
        designation: '3D Artist',
        image: { src: team_member_MatthewS, alt: 'Matthew Silvestri' },
        hover: { src: team_member_MatthewS_Hover, alt: 'Matthew Silvestri' },
        social: []
    }
];